export const MAX_FILE_SIZE_MBS = 6;
export const FILE_SIZE_KB_DIVISOR = 1024;
export const FILE_SIZE_MB_DIVISOR = 1024 * 1024;

export const MAX_FILE_SIZE = MAX_FILE_SIZE_MBS * 1024 * 1024;
export const SCALING_BUFFER = 0.1;

export const MIN_IMAGE_WIDTH = 512;
export const MIN_IMAGE_HEIGHT = 512;
